<template>
  <form @submit.prevent="showSubmitConfirmation">
    <div>
      <div class="spinner-wrap" v-if="!dataIsLoaded">
        <Spinner />
      </div>
      <div class="content-wrap" v-else>
        <div class="content">
          <div class="assessments-wrap">
            <!-- Company Information -->
            <div class="row">
              <h3 class="category-title">Company Information</h3>
              <div class="question-wrap">
                <label class="Header"
                  >1. Please provide your company contact information
                  below.</label
                >
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Name (and dba if applicable)<strong> *</strong></label>
                <div class="question-input Text">
                  <input
                    type="text"
                    required
                    class="form-control"
                    v-model="assessment.companyName"
                    @change="() => saveAssessment(false)"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Address Street 1<strong> *</strong></label>
                <div class="question-input Text">
                  <input
                    type="text"
                    required
                    class="form-control"
                    v-model="assessment.companyAddressStreet1"
                    @change="() => saveAssessment(false)"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Address Street 2</label>
                <div class="question-input Text">
                  <input
                    type="text"
                    class="form-control"
                    v-model="assessment.companyAddressStreet2"
                    @change="() => saveAssessment(false)"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Address City<strong> *</strong></label>
                <div class="question-input Text">
                  <input
                    type="text"
                    required
                    class="form-control"
                    v-model="assessment.companyAddressCity"
                    @change="() => saveAssessment(false)"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Address State<strong> *</strong></label>
                <div class="question-input Text">
                  <select
                    v-model="assessment.companyAddressState"
                    @change="() => saveAssessment(false)"
                    required
                  >
                    <option value="">Select a state</option>
                    <option value="Alabama">Alabama</option>
                    <option value="Alaska">Alaska</option>
                    <option value="Arizona">Arizona</option>
                    <option value="Arkansas">Arkansas</option>
                    <option value="California">California</option>
                    <option value="Colorado">Colorado</option>
                    <option value="Connecticut">Connecticut</option>
                    <option value="Delaware">Delaware</option>
                    <option value="Florida">Florida</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Hawaii">Hawaii</option>
                    <option value="Idaho">Idaho</option>
                    <option value="Illinois">Illinois</option>
                    <option value="Indiana">Indiana</option>
                    <option value="Iowa">Iowa</option>
                    <option value="Kansas">Kansas</option>
                    <option value="Kentucky">Kentucky</option>
                    <option value="Louisiana">Louisiana</option>
                    <option value="Maine">Maine</option>
                    <option value="Maryland">Maryland</option>
                    <option value="Massachusetts">Massachusetts</option>
                    <option value="Michigan">Michigan</option>
                    <option value="Minnesota">Minnesota</option>
                    <option value="Mississippi">Mississippi</option>
                    <option value="Missouri">Missouri</option>
                    <option value="Montana">Montana</option>
                    <option value="Nebraska">Nebraska</option>
                    <option value="Nevada">Nevada</option>
                    <option value="New Hampshire">New Hampshire</option>
                    <option value="New Jersey">New Jersey</option>
                    <option value="New Mexico">New Mexico</option>
                    <option value="New York">New York</option>
                    <option value="North Carolina">North Carolina</option>
                    <option value="North Dakota">North Dakota</option>
                    <option value="Ohio">Ohio</option>
                    <option value="Oklahoma">Oklahoma</option>
                    <option value="Oregon">Oregon</option>
                    <option value="Pennsylvania">Pennsylvania</option>
                    <option value="Rhode Island">Rhode Island</option>
                    <option value="South Carolina">South Carolina</option>
                    <option value="South Dakota">South Dakota</option>
                    <option value="Tennessee">Tennessee</option>
                    <option value="Texas">Texas</option>
                    <option value="Utah">Utah</option>
                    <option value="Vermont">Vermont</option>
                    <option value="Virginia">Virginia</option>
                    <option value="Washington">Washington</option>
                    <option value="West Virginia">West Virginia</option>
                    <option value="Wisconsin">Wisconsin</option>
                    <option value="Wyoming">Wyoming</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Address Zip<strong> *</strong></label>
                <div class="question-input Text">
                  <input
                    type="text"
                    required
                    class="form-control"
                    @input="filterZip"
                    v-model="assessment.companyAddressZip"
                    @change="() => saveAssessment(false)"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Website<strong> *</strong></label>
                <div class="question-input Text">
                  <input
                    type="text"
                    required
                    class="form-control"
                    v-model="assessment.companyWebsite"
                    @change="() => saveAssessment(false)"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Phone Number<strong> *</strong></label>
                <div class="question-input Text">
                  <input
                    type="text"
                    required
                    class="form-control"
                    @input="formatPhoneNumber"
                    v-model="assessment.phoneNumber"
                    @change="() => saveAssessment(false)"
                    placeholder="(555) 555-5555"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Contact Name & Title<strong> *</strong></label>
                <div class="question-input Text">
                  <input
                    type="text"
                    required
                    class="form-control"
                    v-model="assessment.contactNameAndTitle"
                    @change="() => saveAssessment(false)"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Contact Email Address<strong> *</strong></label>
                <div class="question-input Text">
                  <input
                    type="email"
                    required
                    class="form-control"
                    v-model="assessment.contactEmail"
                    @change="() => saveAssessment(false)"
                  />
                </div>
              </div>
            </div>

            <!-- Contact Information -->
            <div class="row">
              <div class="question-wrap">
                <label class="Header"
                  >2. Please list the contact information for each of the
                  following:</label
                >
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Director of Operations<strong> *</strong></label>
                <div class="question-input Text">
                  <input
                    type="text"
                    class="form-control"
                    required
                    v-model="assessment.directorOfOperations"
                    @change="() => saveAssessment(false)"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Chief Pilot<strong> *</strong></label>
                <div class="question-input Text">
                  <input
                    type="text"
                    class="form-control"
                    required
                    v-model="assessment.chiefPilot"
                    @change="() => saveAssessment(false)"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Chief Safety Officer<strong> *</strong></label>
                <div class="question-input Text">
                  <input
                    type="text"
                    class="form-control"
                    required
                    v-model="assessment.chiefSafetyOfficer"
                    @change="() => saveAssessment(false)"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="question-wrap">
                <label class="Text">Director of Maintenance<strong> *</strong></label>
                <div class="question-input Text">
                  <input
                    type="text"
                    class="form-control"
                    required
                    v-model="assessment.directorOfMaintenance"
                    @change="() => saveAssessment(false)"
                  />
                </div>
              </div>
            </div>

            <!-- Dynamic form -->
            <div class="row" v-for="question of assessment.questions">
              <h3 class="category-title" v-if="isNewCategory(question)">
                {{ question.category }}
              </h3>

              <div class="question-wrap">
                <!-- Question types:
								Text
								Radiobutton
								Yes/No
								Multiline textbox
								Yes/No/else
								Date
							-->

                <label :class="question.questionType === 'Yes/No/else' ? 'yes-no-else-label': question.questionType"> 
                  <span v-if="question.questionType === 'File'" class="label-file" v-html="formatFileQuestion(question.question, question.required)"></span>
                  <span v-else-if="question.questionType === 'Header2'" class="label-header" v-html="formatHeaderQuestion(question.question)"></span>
                  <span v-else>{{ question.question }}</span>
                  <strong v-if="question.required && question.questionType !== 'Header' && question.questionType !== 'File'"> *</strong>
                </label>

                <!-- <div class="question-input" v-if="question.questionType === 'Header'">
                  <p :class="question.questionType">{{question.headerText}}</p>
                </div> -->

                <!-- <div class="question-input" v-if="question.questionType === 'Radiobutton'">
								<div v-for="option in question.options" :class="question.questionType">
									<input :required="!!question.required && !question.answer" type="radio" class="form-control" v-model="question.answer" :name="option.id + 'Name'" :value="option.option" @change="() => saveAssessment(false)" :id="option.id" />
									<label :for="option.id">{{ option.option }}</label>
								</div>
							</div> -->

                <div
                  class="question-input"
                  v-if="question.questionType === 'Radiobutton'"
                >
                  <div
                    v-for="option in question.options"
                    :class="question.questionType"
                  >
                    <input
                      v-if="option.option == 'Other'"
                      :required="!!question.required && !question.answer"
                      type="radio"
                      class="form-control"
                      :name="question.id + 'Other'"
                      value=""
                      @change="
                        () => {
                          question.answer = 'Other:';
                          $forceUpdate();
                          saveAssessment(false);
                        }
                      "
                      v-bind="{ checked: question.answer && question.answer.includes('Other') }"
                    />
                    <input
                      v-else
                      :required="!!question.required && !question.answer"
                      type="radio"
                      class="form-control"
                      v-model="question.answer"
                      :name="option.id + 'Name'"
                      :value="option.option"
                      @change="
                        () => {
                          $forceUpdate();
                          saveAssessment(false);
                        }
                      "
                      :id="option.id"
                    />
                    <label :for="option.id">{{ option.option }}</label>
                  </div>

                  <div
                    :class="question.questionType"
                    class="Radiobutton"
                    v-if="showPleaseSpecify(question.answer)"
                  >
                    <label>Please Specify</label>
                    <textarea
                      class="form-control"
                      @change="
                        e => {
                          question.answer = 'Other: ' + e.target.value;
                          saveAssessment(false);
                        }
                      "
                      >{{ question.answer.replace("Other:", "") }}</textarea
                    >
                  </div>
                </div>

                <div
                  class="question-input"
                  :class="question.questionType"
                  v-else-if="question.questionType === 'Yes/No'"
                >
                  <div :class="question.questionType" class="Radiobutton">
                    <input
                      :required="!!question.required && !question.answer"
                      type="radio"
                      class="form-control"
                      v-model="question.answer"
                      :name="question.id + 'Yes'"
                      value="Yes"
                      @change="() => saveAssessment(false)"
                    />
                    <label :for="question.id + 'Yes'">Yes</label>
                  </div>
                  <div :class="question.questionType" class="Radiobutton">
                    <input
                      :required="!!question.required && !question.answer"
                      type="radio"
                      class="form-control"
                      v-model="question.answer"
                      :name="question.id + 'No'"
                      value="No"
                      @change="() => saveAssessment(false)"
                    />
                    <label :for="question.id + 'No'">No</label>
                  </div>
                </div>

                <div
                  class="question-input"
                  :class="question.questionType"
                  v-else-if="question.questionType === 'Multiline textbox'"
                >
                  <textarea
                    class="form-control"
                    v-model="question.answer"
                    @change="() => saveAssessment(false)"
                    rows="4"
                  />
                </div>

                <div
                  class="question-input"
                  :class="question.questionType"
                  v-else-if="question.questionType === 'Yes/No/else'"
                >
                  <div :class="question.questionType" class="Radiobutton">
                    <input
                      :required="!!question.required && !question.answer"
                      type="radio"
                      class="form-control"
                      v-model="question.answer"
                      :name="question.id + 'Yes'"
                      value="Yes"
                      @change="
                        () => {
                          $forceUpdate();
                          saveAssessment(false);
                        }
                      "
                    />
                    <label :for="question.id + 'Yes'">Yes</label>
                  </div>
                  <div :class="question.questionType" class="Radiobutton">
                    <input
                      :required="!!question.required && !question.answer"
                      type="radio"
                      class="form-control"
                      v-model="question.answer"
                      :name="question.id + 'No'"
                      value="No"
                      @change="
                        () => {
                          $forceUpdate();
                          saveAssessment(false);
                        }
                      "
                    />
                    <label :for="question.id + 'No'">No</label>
                  </div>

                  <div :class="question.questionType" class="Radiobutton">
                    <input
                      :required="!!question.required && !question.answer"
                      type="radio"
                      class="form-control"
                      :name="question.id + 'Other'"
                      value=""
                      @change="
                        () => {
                          question.answer = 'Other:';
                          $forceUpdate();
                          saveAssessment(false);
                        }
                      "
                      v-bind="{
                        checked:
                          question.answer &&
                          question.answer !== 'Yes' &&
                          question.answer !== 'No'
                      }"
                    />
                    <label :for="question.id + 'Other'">Other</label>
                  </div>
                  <div
                    :class="question.questionType"
                    class="Radiobutton"
                    v-if="
                      question.answer &&
                      question.answer !== 'Yes' &&
                      question.answer !== 'No'
                    "
                  >
                    <label>Please Specify</label>
                    <!-- Remove "Other: " from textarea view -->
                    <textarea
                      class="form-control"
                      @change="
                        e => {
                          question.answer = 'Other: ' + e.target.value;
                          saveAssessment(false);
                        }
                      "
                      >{{ question.answer ? question.answer.replace("Other:", "") : "" }}</textarea
                    >
                  </div>

                </div>

                <div
                  class="question-input"
                  :class="question.questionType"
                  v-else-if="question.questionType === 'Date'"
                >
                  <!-- Dates are stored as text and should be read/written in a format of mm/dd/yyyy -->
                  <input
                    type="date"
                    :required="question.required"
                    class="form-control"
                    @change="
                      e => {
                        question.answer = writeFormatedDate(e.target.value);
                        saveAssessment(false);
                      }
                    "
                    :value="readFormatedDate(question.answer)"
                  />
                </div>

                <div
                  class="question-input"
                  :class="question.questionType"
                  v-else-if="
                    !question.questionType || question.questionType === 'Text'
                  "
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="question.answer"
                    @change="() => saveAssessment(false)"
                  />
                </div>

                <div
                  class="question-input"
                  :class="question.questionType"
                  v-else-if="
                    !question.questionType ||
                      question.questionType === 'Numeric'
                  "
                >
                  <input
                    type="text"
                    :required="question.required"
                    class="form-control"
                    @input="filterNumbers(question)"
                    v-model="question.answer"
                    @change="() => saveAssessment(false)"
                  />
                </div>

                <div
                  class="question-input"
                  :class="question.questionType"
                  v-else-if="question.questionType === 'File'"
                >
                  <input
                    :required="question.required"
                    type="file"
                    class="form-control"
                    @change="($event) => { question.file = $event.target.files[0]; saveAssessment(false); }"
                  />
                </div>

                <!-- <p>{{question}}</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-wrap" v-if="dataIsLoaded">
        <div class="footer-wrap-content">
          <!--				<HeadBtn text="Submit" :click="() => saveAssessment(true)" />-->
          <button style="background: none; border: none" type="submit">
            <HeadBtn text="Final Submit" :click="() => {}" />
          </button>
          <span class="submit-message">Once you submit the report, you will not be able to make any further updates.</span>
        </div>
      </div>
    </div>

    <SubmitConfirmation
      :on-confirm="() => saveAssessment(true)"
      :on-cancel="cancelPopup"
      report-name="Assessment"
      v-if="showSubmitPopup"
    />

  </form>
</template>

<script>
import Spinner from "../../components/Spinner.vue";
import HeadBtn from "../../components/HeadBtn.vue";
import SubmitConfirmation from "@/components/pop-up/SubmitConfirmation.vue";
import { getAssessmentRid } from "@/api/assessments";

let currentCategory = "all";

export default {
  name: "Assessment",
  data: function() {
    return {
      dataIsLoaded: false,
      showSubmitPopup: false,
      assessment: {
        phoneNumber: "",
        number: "",
        companyAddressZip: ""
      },
      questions: [],
      assessmentRid: null
    };
  },
  components: {
    Spinner,
    HeadBtn,
    SubmitConfirmation
  },
  async mounted() {
    await this.getRealAssessmentId();
    await this.loadAssessment();

    window.scrollTo(0, 0);
  },
  watch: {
    "this.assessmentRid": "loadAssessment",
  },
  methods: {

    async getRealAssessmentId() {
      const encodedRid = this.$route.path.split('/').pop();
  
      const response = await getAssessmentRid(encodedRid);
      this.assessmentRid = response.assessmentRid
    },

    formatFileQuestion(question, isRequired) {
      const hasNumberDot = /\d+\./.test(question);

      if (!hasNumberDot) {
        return `<span>${question}<strong> *</strong></span>`;
      }

      const splitQuestion = question.split(/(\d+\..*?(?=\d+\.|$))/g);

      const formattedParts = splitQuestion
        .filter(part => part.trim() !== "")
        .map((part, index) => {
          if (/^\d+\./.test(part)) {
            return `<span class="number-dot">${part.trim()}</span>`;
          }
          return `<span>${part.trim()}</span>`;
        });

      if (isRequired) {
        formattedParts[0] = `<span>${formattedParts[0]}<strong> *</strong></span>`;
      }

      return formattedParts.join(" ");
    },

    formatHeaderQuestion(question) {
      if (!question.includes("•")) {
        return `<span>${question}</span>`;
      }

      return question
        .split("•")
        .filter(line => line.trim() !== "")
        .map(line => {
          const parts = line.split(":");
          if (parts.length === 2) {
            return `<span class="header-content"><span class="left">• ${parts[0].trim()}:</span><span class="right">${parts[1].trim()}</span></span>`;
          }
          return `<span>${line.trim()}</span>`;
        })
        .join(""); 
    },
    
    showSubmitConfirmation() {
      this.showSubmitPopup = true;
    },

    cancelPopup() {
      this.showSubmitPopup = false;
    },

    async loadAssessment() {
      this.$store.commit("header/setData", {
        title: ``,
        description: ``,
        showLogo: true,
        showLogoutBtn: false
      });

      this.dataIsLoaded = false;
      this.assessment = await this.$store.dispatch(
        "assessments/fetchEntryData",
        this.assessmentRid
      );

      console.log("this.assessment", this.assessment)
      console.log("5elem", this.assessment.questions[5])

      // this.questions = await this.$store.dispatch('assessments/fetchAssessmentQuestions', this.$route.params.id);
      this.dataIsLoaded = true;

      if (!this.assessment) {
        console.error(`Assessment with id ${this.assessmentRid} not found.`);
      }

      this.$store.commit("header/setData", {
        title: `Assessment for ${this.assessment.operatorName}`,
        description: ``,
        showLogo: true,
        showLogoutBtn: false
      });
    },

    async saveAssessment(finished = false) {
      this.showSubmitPopup = false;

      // if (finished) this.dataIsLoaded = false;

      if (finished) {
        this.dataIsLoaded = false;
        this.assessment.completionDate = new Date().toISOString().split('T')[0];

        // Remove "Other: " from yes/no/other questions

        // this.assessment.questions.forEach(question => {
        //   if (
        //     (question.questionType === "Yes/No/else" ||
        //       question.questionType === "Radiobutton") &&
        //     question.answer.startsWith("Other: ")
        //   ) {
        //     question.answer = question.answer.replace("Other: ", "");
        //   }
        // });

      }

      await this.encodeFilesInQuestions();
      
      await this.$store.dispatch("assessments/saveAssessment", {
        data: this.assessment
      });
      this.dataIsLoaded = true;

      if (finished) this.$router.push({ name: "ThankYou" });
    },

    encodeFilesInQuestions() {
      return new Promise(resolve => {
        let noQuestionsEncoding = 0;

        this.assessment.questions.forEach(question => {
          if (question.questionType === "File") {
            const file = question.file;
            if (file) {
              const reader = new FileReader();
              noQuestionsEncoding++;

              reader.onload = () => {
                const encoded = this.arrayBufferToBase64(reader.result);
                question.answer = `${file.name}!${encoded}`;
                noQuestionsEncoding--;

                if (noQuestionsEncoding === 0) {
                  resolve();
                }
              };

              reader.onerror = (error) => {
                console.error("Error:", error);
                noQuestionsEncoding--;
                if (noQuestionsEncoding === 0) {
                  resolve();
                }
              };

              reader.readAsArrayBuffer(file);
            }
          }
        });

        if (noQuestionsEncoding === 0) {
          resolve();
        }
      });
    },

    arrayBufferToBase64(buffer) {
      let binary = "";
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;

      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }

      return btoa(binary);
    },

    isNewCategory(question) {
      if (question.category !== currentCategory) {
        currentCategory = question.category;
        return true;
      }
    },
    readFormatedDate(date) {
      if (!date) return "";
      let dateParts = date.split("/");
      return `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`;
    },
    writeFormatedDate(date) {
      console.log(date);
      if (!date) return "";

      let month = date.split("-")[1];
      let day = date.split("-")[2];
      let year = date.split("-")[0];

      return `${month}/${day}/${year}`;
    },

    formatPhoneNumber() {
      let input = this.assessment.phoneNumber;
      input = input.replace(/\D/g, "");

      // Format (123) 456-6789
      if (input.length > 0) {
        input = "(" + input;
      }
      if (input.length > 4) {
        input = input.slice(0, 4) + ") " + input.slice(4);
      }
      if (input.length > 9) {
        input = input.slice(0, 9) + "-" + input.slice(9, 13);
      }

      this.assessment.phoneNumber = input;
    },

    filterZip() {
      this.assessment.companyAddressZip = this.assessment.companyAddressZip.replace(
        /\D/g,
        ""
      );
    },

    filterNumbers(question) {
      question.answer = question.answer.replace(/[^0-9.]/g, "");

      if (question.answer.startsWith(".")) {
        question.answer = question.answer.substring(1);
      }

      const parts = question.answer.split(".");
      if (parts.length > 2) {
        question.answer = `${parts[0]}.${parts[1]}`;
      }
    },
    
    showPleaseSpecify(answer) {
      if (!answer) {
        return false;
      }

      if (String(answer || "").includes("Other")) {
        return true
      }
      // if (answer) {
      //   return answer.includes("Other");
      // }

      // return answer.includes("Other");
    }
  }
};
</script>

<style scoped>
.btn-primary {
  background-color: #007bff;
  color: #fff;
}

.spinner-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.content-wrap {
  display: flex;
  flex-direction: column;
}

.slider {
  background-color: #1e4775;
  padding: 20px;
  border-bottom: 1px solid #dee2e6;
}

.assessments-wrap {
  display: flex;
  flex-direction: column;

  padding: 0 1.5em 1.5em;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.content {
  max-width: 900px;
  margin: 0px auto 96px;
  width: 95%;
}

.assessments-wrap .header {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.assessments-wrap .header .row {
  display: flex;
  justify-content: space-between;
}

.assessments-wrap .content .row {
  margin-bottom: 20px;
}

.question-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 7px 2em;
  /*//0.35em*/
  background: #efefef;
  font-weight: 500;
}

.question-wrap label {
  /*margin-bottom: 5px;*/
  margin: auto 0;
  width: 36%;
  text-align: left;
  /* padding-right: 1em; */
  /*padding-top: 0.65em;*/
  /*color: #666;*/
  color: #0f2e50;
  font-size: 1.3em;
  /* display: flex;
		align-items: center;
		justify-content: flex-end; */
}

.question-wrap label.Radiobutton {
  margin: 10px 0 0 0;
}

.submit-message {
  margin-left: 30px;
  color: #0f2e50;
  font-size: 1.1em;
  font-weight: 600;
  position: relative;
  top: 5px;
  font-style: italic;
}

/* strong {
  color: rgb(191, 30, 46);
} */

.question-wrap .yes-no-else-label {
  margin: 15px 0;
}

.question-wrap input {
  /*margin-bottom: 10px;*/
  padding: 10px;
  flex: 1;
  border: 1px solid white;
  font-family: "Poppins", sans-serif;
  font-size: 1.25em;
  /*font-size: 15px;*/
  cursor: pointer;
  /*border-radius: 8px;*/
  outline: none;
  /*color: #4e4e4e;*/
  color: #333;
}

.question-wrap input:hover {
  border: 1px solid #0f2e50;
}

.question-wrap input:focus {
  border: 1px solid black;
}

.question-input textarea {
  margin-top: 10px;
  padding: 10px;
  flex: 1;
  border: 1px solid white;
  font-family: "Poppins", sans-serif;
  font-size: 1.25em;
  cursor: pointer;
  /*border-radius: 8px;*/
  outline: none;
  /*color: #4e4e4e;*/
  color: #333;
}

.question-input textarea:hover {
  border: 1px solid #0f2e50;
}

.question-input textarea:focus {
  border: 1px solid black;
}

/* .question-input,
.question-input input:not([type="radio"]),
.question-input textarea {
  width: 95%;
} */

.question-input  {
  width: 62%;
}

.question-input input:not([type="radio"]),
.question-input textarea {
  width: 100%;
}

.category-title {
  font-size: 1.5em;
  font-weight: 700;
  padding: 2em 0 0.5em;
  margin: 0;

  border-top: 0.75em solid #efefef;
  border-bottom: 0.75em solid #efefef;
  border-left: none;
  border-right: none;
}

select {
  width: 100%;
  padding: 10px;
  border: 1px solid white;
  font-family: "Poppins", sans-serif;
  font-size: 1.25em;
  cursor: pointer;
  /*border-radius: 8px;*/
  outline: none;
  /*color: #4e4e4e;*/
  color: #333;
}

select:hover {
  border: 1px solid #0f2e50;
}

select:focus {
  border: 1px solid black;
}

.row:first-child .category-title {
  border-top: none;
}

.Header {
  font-size: 1.7em !important;
}

.question-wrap .Header {
  width: 100%;
  text-align: left;
  color: #0f2e50;
  font-weight: 500;
  margin-bottom: 20px;
  /*color: #414141;*/
}

.question-input .Radiobutton input[type="radio"] {
  margin-right: 10px;
}

.question-input .Radiobutton {
  /* padding-bottom: 1em; */
  padding-top: 0.25em;
}

.question-input .Radiobutton:first-child {
  padding-top: 0.65em;
}

.question-input .Radiobutton label {
  /* display: initial; */
  padding-top: 0;
  /*color: #4e4e4e;*/
  color: #333;
}

.c-head-btn {
  margin: 20px 0 10px 0;
}

.footer-wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1.5px solid #c9cacb;
}

.footer-wrap-content {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.footer-wrap .c-head-btn {
  width: fit-content;
}

@media screen and (max-width: 768px) {
  .category-title {
    font-size: 1.3em;
  }

  .Header {
    font-size: 1.4em !important;
  }

  .submit-message {
    font-size: 1em;
    margin-left: 15px;
  }

  .question-wrap label {
    font-size: 1.1em;
  }

  .question-wrap input,
  .question-input textarea,
  select {
    font-size: 1.05em;
  }
}

@media screen and (max-width: 550px) {
  .content {
    width: 100%;
    margin-bottom: 90px;
  }

  .category-title {
    padding: 1em 0 0.25em;
    font-size: 1.1em;
    border-bottom: none;
  }

  .question-wrap {
    flex-direction: column;
    padding: 0.2em 1em;
  }

  .question-wrap label {
    margin-bottom: 5px;
  }

  .question-wrap .Header {
    width: 100%;
    text-align: left;
    font-size: 1.15em !important;
    padding-right: 0;
    margin: 10px 0;
  }

  .question-wrap .Text {
    width: 100%;
    text-align: left;
    font-size: 1em;
    padding-top: 0.3em;
  }

  .question-wrap input {
    /*margin-bottom: 5px;*/
    font-size: 0.9em;
  }

  .question-input.Text {
    padding-top: 0;
  }

  select {
    font-size: 0.9em;
  }

  label.Radiobutton,
  .question-wrap label {
    width: 100%;
    text-align: left;
    font-size: 1em;
    margin-top: 7px;
  }

  label.Radiobutton {
    margin: 10px 0 4px 0;
  }

  .question-input .Radiobutton {
    padding-top: 0.25em !important;
  }

  .question-input .Radiobutton label {
    font-size: 0.9em;
  }

  .question-input textarea {
    font-size: 0.9em;
  }

  .c-head-btn {
    margin: 10px 0;
  }

  .footer-wrap-content {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 0 1.5em;
  }

  .submit-message {
    margin: 0 0 10px 0;
    position: static;
    text-align: center;
  }
}
</style>

<style>
  .number-dot {
    /* display: block; */
    font-size: 0.9em;
    padding-left: 20px;
  }

  .question-wrap strong {
    color: rgb(191, 30, 46);
  }

  .Header2 {
    width: 100% !important;
  }

  .Line {
    width: 100% !important;
    height: 2px;
    background-color: #000;
  }

  .label-file {
    display: flex;
    flex-direction: column;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    font-size: 0.8em;
  }

  .header-content:not(:last-child) {
    margin-bottom: 7px;
  }

  .header-content .left{
    width: 49%;
  }

  .header-content .right{
    width: 49%;
  }
</style>
